import { useState } from 'react';
import { downloadFilesAsZip, extractFailedFiles } from '@tools/ui/api';
import { downloadFile } from '@tools/ui-utils/files.util';
import { openToast } from '@tools/ui-utils/toast.util';
import useT from './useT';

export const MAX_DOWNLOAD_FILES = 15;

export const useDownloadFilesAsZip = () => {
  const { t } = useT();
  const [isDownloading, setIsDownloading] = useState(false);

  const download = async (fileIds: number[], partnerName: string | null) => {
    if (fileIds.length > MAX_DOWNLOAD_FILES) {
      openToast({
        type: 'error',
        message: t('files.downloadTooMany', { max: MAX_DOWNLOAD_FILES })
      });
      return;
    }

    setIsDownloading(true);
    try {
      const blob = await downloadFilesAsZip(fileIds, partnerName);
      const date = new Date().toISOString().slice(0, 10);
      downloadFile({ url: blob, fileName: `attachments-${date}.zip` });
    } catch (error) {
      const failedFiles = await extractFailedFiles(error);
      openToast({
        type: 'error',
        message: failedFiles.length
          ? t('files.downloadFailed', { files: failedFiles.join(', ') })
          : t('files.downloadFailedGeneric')
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return { download, isDownloading };
};
